/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { City } from '@app/settings/cities/cities.model';
import { CitiesSeoFormComponent } from '@app/settings/cities/cities-seo-form/cities-seo-form.component';

@Injectable({
  providedIn: 'root',
})
export class CitiesSeoFormService {
  constructor(private modalService: NgbModal) {}

  public open(city: null | City = null): Promise<any> {
    const modal = this.modalService.open(CitiesSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.city = city;
    return modal.result;
  }
}
